import { Navigate } from "react-router-dom";
import { LevelSpecificRoute, ERouteContext, ESharedRoutes } from "routes/types";
import { getSharedRoutes } from "./sharedRoutesUtil";
import { Route } from "react-router-dom";


const baseSharedRoutes = [
  ESharedRoutes.PRICING,
  ESharedRoutes.SETTINGS,
  ESharedRoutes.THEME,
  ESharedRoutes.PRODUCTS,
  ESharedRoutes.OFFERS_UI,
  ESharedRoutes.BADGES,
  ESharedRoutes.ASSETS,
  ESharedRoutes.BUNDLES,
  ESharedRoutes.PROMOTIONS,
  ESharedRoutes.POPUPS,
  ESharedRoutes.ROLLING,
  ESharedRoutes.CHECKOUT_LINKS,
  ESharedRoutes.PROFILE
];

export const createStoreRoutes = (
  basePath: string,
  defaultPage: string,
  context: ERouteContext,
  levelSpecificRoutes: LevelSpecificRoute[] = []
) => {
  const sharedRoutesList = context === ERouteContext.PROJECT ? [
    ESharedRoutes.PLAYERS, 
    ESharedRoutes.LOCALIZATION,
    ...baseSharedRoutes] : 
    baseSharedRoutes;
  
  return (
    <Route path={`${basePath}/*`}>
      <Route path="" element={<Navigate to={defaultPage} replace />} />
      {levelSpecificRoutes.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}
      {sharedRoutesList.map(route => getSharedRoutes(route, context))}
    </Route>
  );
};  